import httpClient from "@/_shared/http-client";
import { objectHelper, httpHelper } from "@/_shared/utils";

import responseAdapter from "@/business/api-services/_responseAdapter";
import urlBuilder from "@/business/api-services/_urlBuilder";

const getClient = async (id = 1) => {
  let results = {};
  const url = urlBuilder.buildForContactForm(id, 'clients');
  await httpClient
    .get(url)
    .then(({ data }) => (
      results = responseAdapter.adaptForContactForm(data, 'client')
    ));
  return results;
};

const handleClient = (httpMethod = 'post') => async (body = {}) => {
  body = objectHelper.createCopy(body);
  body.data = httpHelper.addDateField(body.client, httpMethod);
  body.type = 'client';
  delete body.client;
  const url = new URL(`${process.env.BACKEND_URL}/business/contacts`);
  const response = await httpClient[httpMethod](url, body).catch(({ response }) => {
    throw new Error(response.data.message)
  });;
  return response;
};

export const clientService = {
  get: (id) => getClient(id),
  add: handleClient('post'),
  edit: handleClient('patch'),
};



// WEBPACK FOOTER //
// ./src/business/api-services/clientService.js